// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"caa7294e","label":"ed46e5b6","pdfList":"d0d4e70c","pdf":"da04406a","textSection":"d1e6c068","form":"f85dc70a","created":"c5366c9b"};